import React from 'react';
import { CircularProgress, createStyles, Dialog, makeStyles, Theme } from '@material-ui/core';

interface ILoadingDialogProps {
    open: boolean
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    loading: {
        margin: theme.spacing(4),
        textAlign: 'center'
    },
}));
  
export function LoadingDialog({open}: ILoadingDialogProps) {
    const classes = useStyles();
  
    return (
        <Dialog 
            aria-labelledby="loading-dialog-title" 
            open={open} 
            PaperProps={{
                style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            }}
        >
            <CircularProgress 
                color="primary" 
                size="124px" 
                className={classes.loading} 
            />  
        </Dialog>

    );
}